export default __webpack_public_path__ + "static/media/1-3.ab13d374.png";